import { Col, Row } from 'react-bootstrap';
import FormTextField from '../../../formFields/FormTextField';
import FormDateTimeField from '../../../formFields/FormDateTimeField';

const SafetyPlanBasicFields = () => {
  return (
    <>
      <Row className="g-2">
        <Col xs={12} md={4}>
          <FormTextField
            title="Safety Officer"
            fieldName="safetyOfficer"
            placeholder="Enter name..."
            rules={{
              maxLength: {
                value: 255,
                message: 'Maximum length is 255 characters',
              },
            }}
            variant="none"
          />
        </Col>
        <Col xs={12} md={4}>
          <FormTextField
            title="Duty Phone"
            fieldName="dutyPhone"
            placeholder="Enter phone..."
            rules={{
              maxLength: {
                value: 255,
                message: 'Maximum length is 255 characters',
              },
            }}
            variant="none"
          />
        </Col>
        <Col xs={12} md={4}>
          <FormTextField
            title="Email"
            fieldName="email"
            placeholder="Enter email..."
            rules={{
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                message: 'Invalid email address',
              },
              maxLength: {
                value: 255,
                message: 'Maximum length is 255 characters',
              },
            }}
            variant="none"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <FormDateTimeField
            title="Date & Time Initiated"
            fieldName="datetimeInitiated"
            variant="full"
          />
        </Col>
      </Row>
    </>
  );
};

export default SafetyPlanBasicFields;
